import React, { useState } from 'react';
import './login.css';
import firebase from '../../config/firebase';
import 'firebase/auth';
import {Link} from 'react-router-dom';
import { useSelector, useDispatch} from 'react-redux';
import { Redirect } from 'react-router-dom';
import "animate.css"
import logoDelta from './images/logo.png';

function Login(){
    const [carregando, setCarregando] = useState();
    const [email, setEmail] = useState();
    const [senha, setSenha] = useState();
    const [msgTipo, setMsgTipo] = useState();
    
    const dispatch = useDispatch();
    
    function logar(){
        setCarregando(1)
        firebase.auth().signInWithEmailAndPassword(email, senha).then(resultado => {
            setCarregando(0)
            setTimeout(() =>{
                dispatch({type: 'LOG_IN', usuarioEmail: email})       
            },1000); 
        }).catch(erro =>{
            setCarregando(0)
            setMsgTipo('erro')
        });
    }

    return(
        <main className="form-signin">
                {useSelector(state => state.usuarioLogado) > 0 ? <Redirect to='/home' /> : null}
                <img className="animate__animated animate__flash logo-delta" src={logoDelta}/>
                <form className="animate__animated animate__pulse inner-form">
                    {/* <img className="mb-4" src="/docs/5.1/assets/brand/bootstrap-logo.svg" alt="" width="72" height="57"/> */}
                    <h1 className="h3 mb-3 fw-normal">Acesso ao sistema</h1>
                        
                    <div className="form-floating">
                        <input onChange={ (e) => setEmail(e.target.value) } type="email" className="form-control mb-3" id="floatingInput" placeholder="(21)99999-9999"/>
                        <label for="floatingInput">E-mail</label>
                    </div>
                    <div className="form-floating">
                        <input onChange={ (e) => setSenha(e.target.value) } type="password" className="form-control mb-3" id="floatingPassword" placeholder="Senha"/>
                        <label for="floatingPassword">Senha</label>
                    </div>
                    
                    {
                        carregando > 0 ? <button className="w-100 btn btn-lg btn-primary btn-custom-login" type="button" onClick={logar}><div className="spinner-border text-danger" role="status"><span className="sr-only"></span></div></button>
                        
                        : <button className="w-100 btn btn-lg btn-primary btn-custom-login" type="button" onClick={logar}>Entrar</button>
                        
                    }
                    <div className="mt-3">
                            {msgTipo === 'erro' && <span className="msg-error">Por favor, verifique o e-mail e senha.</span>}
                    </div>
                    <Link className="change-pass" to="/mudar-senha">Mudar Senha</Link>
                    <p className="mt-3 mb-3 text-muted text-footer">GRUPO DELTA RIO &copy; 2021</p>
                </form>
            </main>
    )
}

export default Login